import DeleteIcon from '@/assets/icons/DeleteIcon';
import FormItem from '@/components/Common/FormItem/FormItem';
import { NumberInput } from '@/components/Common/NumberInput/NumberInput';
import COLORS from '@/constants/colors';
import { useSnackbarContext } from '@/context/Snackbar/SnackbarContext';
import { useIsMobile } from '@/utils/isMobile';
import ImageNotSupportedOutlinedIcon from '@mui/icons-material/ImageNotSupportedOutlined';
import {
  IconButton,
  OutlinedInput,
  Stack,
  TableCell,
  TableRow,
} from '@mui/material';
import { ProductUi } from '../CartUiModel';

export const ProductLine = ({
  product,
  onChangeProductPrice,
  onChangeProductQuantity,
  onDeleteProduct,
}: {
  product: ProductUi;
  onChangeProductPrice: (productId: string, newPrice: string) => void;
  onChangeProductQuantity: (productId: string, newQuantity: number) => void;
  onDeleteProduct: (productId: string) => void;
}) => {
  const { showSnackWarning } = useSnackbarContext();

  const cellStyle = {
    fontSize: '12px',
    color: COLORS.gray_800,
    borderBottom: 'none',
  };
  const isMobile = useIsMobile();

  return (
    <TableRow
      key={product.id}
      sx={{
        borderTop: `1px solid ${COLORS.gray_7}`,
      }}
    >
      <TableCell sx={{ ...cellStyle, fontWeight: 600 }}>
        {product.sellerName}
      </TableCell>
      <TableCell
        sx={{
          ...cellStyle,
          display: 'flex',
          direction: 'row',
          gap: '16px',
          minWidth: isMobile ? 'auto' : '300px',
        }}
      >
        {product?.imageUrl ? (
          <img
            style={{ width: '44px', height: '44px', alignSelf: 'center' }}
            src={product.imageUrl}
            alt={product.productName || 'prod'}
          />
        ) : (
          <ImageNotSupportedOutlinedIcon
            style={{ width: '16px', height: '16px' }}
          />
        )}

        <Stack>
          <span style={{ fontWeight: 500 }}>{product.productName}</span>
          <span style={{ fontWeight: 500, color: COLORS.gray_500 }}>
            {product.presentation}
          </span>
          <span style={{ fontWeight: 500 }}>{product.pricingLabel}</span>
        </Stack>
      </TableCell>
      <TableCell sx={cellStyle}>
        <FormItem helperText={product.quantityError}>
          <NumberInput
            step={product.quantityStep}
            min={0}
            value={product.quantity}
            onChanged={(newValue) =>
              onChangeProductQuantity(product.id, newValue)
            }
            endAdorment={product.selectorUnitName}
            error={!!product.quantityError}
            onInvalidInput={() => {
              setTimeout(() => showSnackWarning('Cantidad inválida'), 300);
            }}
          />
        </FormItem>
      </TableCell>
      <TableCell sx={cellStyle}>
        <FormItem helperText={product.customPricingError}>
          <OutlinedInput
            value={product.customPricing}
            onChange={(e) => onChangeProductPrice(product.id, e.target.value)}
            startAdornment={<span>$</span>}
            endAdornment={<span>{product.unitName}</span>}
            error={!!product.customPricingError}
          />
        </FormItem>
      </TableCell>
      <TableCell sx={{ ...cellStyle }}>
        <Stack
          direction={'row'}
          alignItems={'center'}
          justifyContent={'space-between'}
        >
          <span>${product.total}</span>
          <IconButton
            aria-label="delete"
            onClick={() => onDeleteProduct(product.id)}
          >
            <DeleteIcon />
          </IconButton>
        </Stack>
      </TableCell>
    </TableRow>
  );
};
